import api from 'api';

import { Document } from 'types/zod/document';

const { Buffer } = require('buffer/');

type AllowedExtensions = 'png' | 'tiff' | 'jpg' | 'jpeg' | 'pdf';

const mimes: Record<AllowedExtensions, string> = {
    png: 'image/png',
    tiff: 'image/tiff',
    jpg: 'image/jpeg',
    jpeg: 'image/jpeg',
    pdf: 'application/pdf',
};

const DocumentScansService = {
    upload: async (params: { documentId: Document['document_id']; filename: string; file: any }): Promise<any> => {
        const { documentId: doc_id, filename, file } = params;
        const path = `/documents/${doc_id}/scans`;
        const { result: signedUrl } = await api.documents.getSignedUrl({ path, filename });
        const buffer = Buffer.from(file?.split?.(`;base64,`)?.[1], 'base64');
        const response = await api.documents.uploadToS3({ signedUrl, buffer, filename, file });
        await api.documents.updateSignedUrl({ path, url: signedUrl });
        return response;
    },
    download: async (params: { documentId: Document['document_id']; filename: string }): Promise<any> => {
        const { documentId, filename: name } = params;
        const { result: path } = await api.documents.getSignedUrlByDocumentIdAndName({ documentId, name });
        const mimeType = mimes[name.split('.').pop()?.toLowerCase() as AllowedExtensions];
        return await api.documents.downloadDocument({ path, mimeType });
    },
};

export default DocumentScansService;
